export default "__VITE_ASSET__BkQ$4iah__"